import { useState } from "react";
import { motion } from "framer-motion";
import diamond from "../images/diamond.png";

export default function DiamondClicker() {
  const [count, setCount] = useState(0);
  const [lore, setLore] = useState("");

  //add diamonds and some lore...
  function click() {
    setCount(count + 1);
    if(count == 10) {
      setLore("Wow 10 clicks!");
    }
    if(count == 20) {
      setLore("Okay you can stop now...");
    }
    if(count == 30) {
      setLore("I am warning you this is the last one!");
    }
    if(count == 50) {
      setLore("The real villain is in the member's page!");
    }
  }

  return (
    <div className="flex flex-col items-center">
      <p className="text-xl mb-2">💎 Diamonds: {count}</p>
      <motion.img
        src={diamond}
        alt="diamond block"
        className="w-48 cursor-pointer select-none"
        whileTap={{ scale: 0.9 }}
        onClick={() => click()}
      />
      <p className="text-xl mb-2">{lore}</p>
    </div>
  );
}